export const ROWS_PER_ANSWER = 20;

export const CHATS_PER_PAGE = 10;

export const MESSAGES_PER_PAGE = 20;

export const ANSWER_TIMEOUT_MS = 30000;

export const MAX_QUESTION_LENGTH = 2000;
